import {FaceOffVerdictValue} from '../../../../services/coreApi/faceoff'
import {FACIAL_RECOGNITION_PATH} from '../../constants'

// Media caps the golden set at these sizes.
export const MAX_GOLDEN_PHOTOS = 50
export const MAX_GOLDEN_CASES = 150

// One key per verdict, matching the first letter of its button name.
export const VERDICT_KEYS: Record<string, FaceOffVerdictValue> = {
  a: 'accept',
  w: 'reject',
  u: 'unsure',
}

// Sub-paths inside the Face Off tab. The tab registry keeps one Face Off
// entry; FacialRecognitionView selects it by path prefix.
export const FACE_OFF_PATH = `${FACIAL_RECOGNITION_PATH}/face-off`
export const FACE_OFF_RUN_PATH = `${FACE_OFF_PATH}/runs/:runId`
export const FACE_OFF_GOLDEN_PATH = `${FACE_OFF_PATH}/golden`
export const FACE_OFF_GOLDEN_VERSION_PATH = `${FACE_OFF_GOLDEN_PATH}/:version`

export const faceOffRunPath = (runId: string): string =>
  `${FACE_OFF_PATH}/runs/${encodeURIComponent(runId)}`

export const faceOffGoldenVersionPath = (version: number): string =>
  `${FACE_OFF_GOLDEN_PATH}/${version}`

/** Fills `{name}` slots in a copy string. */
export const fillCopy = (
  text: string,
  values: Record<string, string | number>,
): string =>
  text.replace(/\{(\w+)\}/g, (slot, name) => String(values[name] ?? slot))
